<template>
  <div class="item-box">
    <!--标题-->
    <div :class="['question-item-title',{isMbottom:question.show_rule.is_check_show}]">
      <span><i v-if="!$store.state.settingData.base.notorder">{{ number }}、</i>
        <span class="q-title" v-html="question.title"></span>
        <Icon type="ios-information-circle" @click="hintShowClick" v-if="question.show_rule.is_check_show && question.show_rule.hint.length>0"/>
      </span>
    </div>
    <span class="title-tips" v-html="question.show_rule.hint" v-if="!question.show_rule.is_check_show"></span>

    <div class="q-content">
      <Form :model="formLabelAlign">
        <FormItem label="姓名：">
          <Input v-model="formLabelAlign.name" @on-blur="inputBlur"></Input>
        </FormItem>
        <FormItem label="所在地区：">
          <Input v-model="formLabelAlign.region" @on-blur="inputBlur"></Input>
        </FormItem>
        <FormItem label="街道地址：">
          <Input v-model="formLabelAlign.address" @on-blur="inputBlur"></Input>
        </FormItem>
        <FormItem label="邮政编码：">
          <Input v-model="formLabelAlign.emailCode" @on-blur="inputBlur"></Input>
        </FormItem>
        <FormItem label="手机/固话：">
          <Input v-model="formLabelAlign.tel" @on-blur="inputBlur"></Input>
        </FormItem>
      </Form>
    </div>
    <!--提示弹框-->
    <Modal class="hintModel" v-model="modal" width="70%" :closable="false">
      <p slot="header">
        <Icon type="ios-information-circle"></Icon>
        <span>填写提示</span>
      </p>
      <div style="color: #4e4c56;font-size: 16px">
        <span v-html="question.show_rule.hint"></span>
      </div>
      <div slot="footer">
        <p @click="clearClick">我知道了</p>
      </div>
    </Modal>
  </div>
</template>

<script>
    export default {
        name: "tMailAddress",
        props: {
            question: {
                type: Object,
                default() {
                    return {}
                }
            },
            number: {
                type: Number,
                default() {
                    return 1;
                }
            },
        },
        data() {
            return {
                formLabelAlign: {
                    name: '',
                    region: '',
                    address: '',
                    emailCode: '',
                    tel: '',
                },
                modal: false
            }
        },
        mounted() {
            if (this.$store.state.user_answers[this.question.id] !== '') {
                this.formLabelAlign = this.$store.state.user_answers[this.question.id]
            }
        },
        methods: {
            inputBlur() {
                let obj = {}
                obj[this.question.id] = this.formLabelAlign
                this.$store.dispatch('userAnswersActions', obj)
            },
            hintShowClick() {
                this.modal = true
            },
            clearClick() {
                this.modal = false
            }
        }
    }
</script>

<style lang="scss" scoped>
  .q-content {
    /deep/ .ivu-form {
      .ivu-form-item {
        margin-bottom: 15px;
        display: flex;
        align-items: center;

        .ivu-form-item-label {
          padding-right: 0;
          font-size: 14px;
          width: 75px;
        }

        .ivu-form-item-content {
          flex: 1;
        }
      }
    }
  }

</style>
